import _ from "lodash";

export const buildDividerStylesheet = (builder, device, cta, element) => {
    let options = { ...element.options };

    let alignmentMargin = "";
    if (
      options["divider-orientation"] == "vertical" &&
      options["cf-alignment"]
    ) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        alignmentMargin = "margin-left: 0px !important;";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        alignmentMargin = "margin-right: 0px !important;";
      }
    }

    // prettier-ignore
    const desktopStyles = 
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-divider-outer {
  ${options["divider-orientation"] !== 'vertical' && options["divider-length"] == 'custom' && options["divider-length-value"] ? 'max-width: ' + options["divider-length-value"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-divider {
  border: initial !important;
  border-${options["divider-orientation"] !== 'vertical' ? 'top' : 'left'}: ${_.isNil(options["divider-border-width"]) == false ? options["divider-border-width"] : 1}px ${options["divider-border-style"] && ['empty', 'none'].includes(options["divider-border-style"]) == false ? options["divider-border-style"] : 'solid'} ${options["divider-border-color"] ? options["divider-border-color"] : '#ccc'} !important;
  opacity: ${['empty', 'none'].includes(options["divider-border-style"]) ? '0' : '1'} !important;
  ${options["divider-orientation"] == 'vertical' ? 'height: ' + (options["divider-length-value"] ? options["divider-length-value"] : 300) + 'px !important;' : ''}
  ${options["divider-orientation"] == 'vertical' ? 'width: ' + (_.isNil(options["divider-border-width"]) == false ? options["divider-border-width"] : 1) + 'px !important;' : ''}
  ${alignmentMargin}
}
`;

    let alignmentMarginMobile = "";
    if (options["divider-orientation"] == "vertical" && options["cf-alignment-mobile"]) {
      if (options["cf-alignment-mobile"].indexOf("left") > -1) {
        alignmentMarginMobile = "margin-left: 0px !important;";
      } else if (options["cf-alignment-mobile"].indexOf("right") > -1) {
        alignmentMarginMobile = "margin-right: 0px !important;";
      }
    }

    // prettier-ignore
    const mobileStyles = 
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] {
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-divider {
  ${alignmentMarginMobile}
}
`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
